import { withProps } from 'recompose'
import { joinClassNames } from '@signifyd/legacy-components'

const withClassName = (sigClassName: string) => {
  return withProps(({ className }) => ({
    className: joinClassNames([sigClassName, className]),
  }))
}

export default withClassName
